/* Home Luz Regia: filtros de la vitrina por necesidad. */
(function () {
  function init() {
    document.querySelectorAll('[data-lrh-vitrina]').forEach(function (root) {
      var chips = root.querySelectorAll('.lrh-chip'), cards = root.querySelectorAll('.lrh-card');
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var f = c.getAttribute('data-f');
          chips.forEach(function (x) { x.classList.toggle('is-on', x === c); x.setAttribute('aria-pressed', x === c); });
          cards.forEach(function (k) {
            var cats = ' ' + (k.getAttribute('data-cats') || '') + ' ';
            k.hidden = !(f === 'todos' || cats.indexOf(' ' + f + ' ') > -1);
          });
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
